import React from "react";
import { Form, Field, FormProps } from "react-final-form";
import * as palette from "@govlaunch/palette";
import { Button } from "@govlaunch/core";
import TagsSelectContainer from "~/components/tag/TagsSelect";
import { ITagType } from "~/types/types";
import { FormattedMessage, useIntl } from "react-intl";

interface IAwardsFormProps {
  onCancel: (args: any) => void;
}

export default function AwardsForm({ onCancel, ...props }: IAwardsFormProps & FormProps) {
  const intl = useIntl();

  return (
    <Form {...props}>
      {({ handleSubmit, submitting }) => (
        <form
          onSubmit={handleSubmit}
          css={{
            margin: 0,
            padding: 0,
          }}
        >
          <Field name="awards">
            {({ input }) => (
              <TagsSelectContainer
                {...input}
                type={ITagType.Award}
                placeholder={intl.formatMessage({
                  defaultMessage: 'Type to select awards...', id: 'OqzbA+',
                })}
              />
            )}
          </Field>

          <div
            css={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: 16,
            }}
          >
            <Button
              type="submit"
              disabled={submitting}
              theme="link"
              textColor={palette.primary}
              css={{
                height: "auto",
                padding: 0,
                textTransform: "uppercase",
                ":disabled": {
                  opacity: 0.4,
                },
              }}
            >
              {submitting ? <FormattedMessage defaultMessage="Saving" id="QLkzoS" /> : <FormattedMessage defaultMessage="Save" id="jvo0vs" />}
            </Button>

            <Button
              type="button"
              onClick={onCancel}
              theme="link"
              textColor={palette.sealBlue}
              css={{
                height: "auto",
                padding: 0,
                marginLeft: 8,
                textTransform: "uppercase",
              }}
            >
              <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
            </Button>
          </div>
        </form>
      )}
    </Form>
  );
}
